import React from 'react'
import Dialog, { DialogTitle, DialogContent, DialogContentText } from 'material-ui/Dialog'
import { withStyles } from 'material-ui/styles/index'

import LoadingButton from '../../../common/components/LoadingButton'
import { cancelAppointmentDialog as styles } from '../styles'
import { cancelAppointmentDialog as text } from '../text'

const CancelAppointmentDialog = ({ classes, open, onClose, onCancel, isLoading }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle className={classes.dialogTitle}>{text.areYouSure}</DialogTitle>
    <DialogContent className={classes.dialogText}>
      <DialogContentText>{text.chargeForCanceling}</DialogContentText>
      <div className={classes.dialogButtonContainer}>
        <LoadingButton
          variant={'secondary'}
          onClick={onCancel}
          isLoading={isLoading}
          className={classes.dialogButton}
        >
          {text.cancelButton}
        </LoadingButton>
      </div>
      <div className={classes.dialogButtonContainer}>
        <LoadingButton
          variant={'secondary'}
          className={classes.dialogButton}
          onClick={onClose}
          isLoading={false}
        >
          {text.closeButton}
        </LoadingButton>
      </div>
    </DialogContent>
  </Dialog>
)

export default withStyles(styles, { withTheme: true })(CancelAppointmentDialog)



// WEBPACK FOOTER //
// ./src/sections/activity/components/cancelAppointmentDialog.js